import React from 'react';
import {
  StopFirstHalf,
  StopFirstHalfAlt,
  StopSecondHalf,
  StyledStarIcon,
} from './styles';
import { StarIconComposedStyling, StarIconStyling } from './types';

const StarIcon: React.FC<StarIconProps> = ({
  title,
  styling = 'inactive',
  height = 13,
  secondaryColors = false,
}) => {
  let modifier: StarIconComposedStyling = styling;
  if (secondaryColors) {
    modifier = `${styling}-alt`;
  }

  return (
    <StyledStarIcon
      $styling={modifier}
      height={height}
      width={height}
      viewBox="0 0 13 13"
    >
      <defs>
        <linearGradient id="halfGradient">
          <StopFirstHalf offset="50%" />

          <StopSecondHalf offset="50%" />
        </linearGradient>
        <linearGradient id="halfGradientAlt">
          <StopFirstHalfAlt offset="50%" />

          <StopSecondHalf offset="50%" />
        </linearGradient>
      </defs>

      {title && <title>{title}</title>}

      <path
        d="M13 4.805c0 .114-.068.24-.203.375L9.96 7.945l.672 3.907c.005.036.008.088.008.156a.46.46 0 0 1-.082.277.276.276 0 0 1-.239.113.632.632 0 0 1-.312-.093L6.5 10.46l-3.508 1.844a.664.664 0 0 1-.312.093c-.11 0-.192-.037-.246-.113a.46.46 0 0 1-.082-.277c0-.031.005-.084.015-.156l.672-3.907L.195 5.18C.065 5.04 0 4.914 0 4.805c0-.193.146-.313.438-.36l3.921-.57L6.117.32c.1-.213.227-.32.383-.32s.284.107.383.32L8.64 3.875l3.921.57c.292.047.438.167.438.36z"
        fill="#002136"
      />
    </StyledStarIcon>
  );
};

interface StarIconProps {
  title?: string;
  styling?: StarIconStyling;
  height?: number;
  secondaryColors?: boolean;
}

export default StarIcon;
